export type EventTimelineKind = 'payment' | 'fx-trade' | 'incoming-payment';

export interface PaymentEventItem {
  payment_event_id: number;
  payment_id: number;
  event_type_code: string;
  event_type_label: string;
  payment_event_timestamp: string;
  payment_event_message: Record<string, unknown>;
}

export interface FxTradeEventItem {
  fx_trade_event_id: number;
  fx_trade_id: number;
  event_type_code: string;
  event_type_label: string;
  fx_trade_event_timestamp: string;
  fx_trade_event_message: Record<string, unknown>;
}

export interface IncomingPaymentEventItem {
  incoming_payment_event_id: number;
  incoming_payment_id: number;
  event_type_code: string;
  event_type_label: string;
  incoming_payment_event_timestamp: string;
  incoming_payment_event_message: Record<string, unknown>;
}

export type AnyEventItem = PaymentEventItem | FxTradeEventItem | IncomingPaymentEventItem;

export interface NormalisedEvent {
  id: number;
  parentId: number;
  eventTypeCode: string;
  eventTypeLabel: string;
  timestamp: string;
  message: Record<string, unknown>;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
}

export interface WalletRecordItem {
  wallet_record_id: number;
  account_wallet_id: number;
  transaction_id: string | null;
  direction: 'D' | 'C';
  amount: string;
  currency_code: string;
  /** Nul tant que l'operation n'est pas reglee — voir `WalletLedgerTable`. */
  value_date: string | null;
  created_at: string;
}

export function normaliseEvent(kind: EventTimelineKind, raw: AnyEventItem): NormalisedEvent {
  if (kind === 'payment') {
    const e = raw as PaymentEventItem;
    return {
      id: e.payment_event_id,
      parentId: e.payment_id,
      eventTypeCode: e.event_type_code,
      eventTypeLabel: e.event_type_label,
      timestamp: e.payment_event_timestamp,
      message: e.payment_event_message,
    };
  }
  if (kind === 'fx-trade') {
    const e = raw as FxTradeEventItem;
    return {
      id: e.fx_trade_event_id,
      parentId: e.fx_trade_id,
      eventTypeCode: e.event_type_code,
      eventTypeLabel: e.event_type_label,
      timestamp: e.fx_trade_event_timestamp,
      message: e.fx_trade_event_message,
    };
  }
  const e = raw as IncomingPaymentEventItem;
  return {
    id: e.incoming_payment_event_id,
    parentId: e.incoming_payment_id,
    eventTypeCode: e.event_type_code,
    eventTypeLabel: e.event_type_label,
    timestamp: e.incoming_payment_event_timestamp,
    message: e.incoming_payment_event_message,
  };
}

export function endpointForKind(kind: EventTimelineKind, parentId: string | number): string {
  const id = encodeURIComponent(String(parentId));
  if (kind === 'payment') return `/api/payments/${id}/events`;
  if (kind === 'fx-trade') return `/api/fx-trades/${id}/events`;
  return `/api/incoming-payments/${id}/events`;
}
